/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PostGroupManagerCreatePostGroupResponse } from "./PostGroupManagerCreatePostGroupResponse";

export type PostGroupManagerCreatePostGroupResponseApiRespoonse = {
  data?: PostGroupManagerCreatePostGroupResponse;
  status?: PostGroupManagerCreatePostGroupResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace PostGroupManagerCreatePostGroupResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
